









import { Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { Mutation } from "vuex-class";

import DocumentsForms from "@/components/falcon/documents/DocumentsForms.vue";
import DocumentsTable from "@/components/falcon/documents/DocumentsTable.vue";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { RouterPathName } from "@/enums/router-path-name.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon documents view component
 */
@Component({
  components: { DocumentsTable, DocumentsForms },
  filters: {
    ...capitalizeFilter
  }
})
export default class DocumentsView extends Vue {
  @Mutation("app/setTitlePrefix") private setTitlePrefix!: (
    newPrefix: string
  ) => void;
  @Watch("$route", { immediate: true, deep: true })
  private routeUpdated(): void {
    this.setTranslatedTitlePrefix();
  }
  @Watch("$i18n.locale") private localeUpdated(): void {
    this.setTranslatedTitlePrefix();
  }

  title = "";
  subTitle = "";
  i18nMessageKeyEnum = I18nMessageKey;

  private setTranslatedTitlePrefix(): void {
    const { documentId } = this.$route.params;
    let title: string;
    let subTitle = "";

    if (
      this.$route.name === RouterPathName.FalconDocumentsWithDocumentDetails &&
      documentId
    ) {
      title = capitalizeFilter.capitalize(
        this.$t(this.i18nMessageKeyEnum.DocumentsModuleTitleDetailsText, {
          documentId
        })
      );
    } else if (
      this.$route.name === RouterPathName.FalconDocumentsView &&
      this.$route.query.selectComplaintDocument
    ) {
      title = capitalizeFilter.capitalize(
        this.$t(
          this.i18nMessageKeyEnum
            .DocumentsModuleTitleSelectComplaintDocumentText
        )
      );
      subTitle = capitalizeFilter.capitalize(
        this.$t(
          this.i18nMessageKeyEnum
            .DocumentsModuleSubTitleComplaintCreationInfoText
        )
      );
    } else {
      title = capitalizeFilter.capitalize(
        this.$t(this.i18nMessageKeyEnum.DocumentsModuleTitleText)
      );
    }
    this.setTitlePrefix(title);
    this.title = title;
    this.subTitle = subTitle;
  }
}
